import React, { useState, useEffect , useRef } from "react";
import { useNavigate } from "react-router-dom";
import "../Products/ProductSlider.css";
import { useSelector } from "react-redux";

const ServiceSlider = ({ service }) => {
  const navigate = useNavigate();
  const [servicesData, setServicesData] = useState([]);
  const { services } = useSelector((state) => state.data);
  const [shouldCenter, setShouldCenter] = useState(false);
    const sliderRef = useRef(null);

  useEffect(() => {
    const checkFit = () => {
      if (sliderRef.current) {
        const containerWidth = sliderRef.current.clientWidth; // Visible width of the container
        const totalCardsWidth = servicesData.length * 295; // Each card width (280px + 15px gap)

        setShouldCenter(totalCardsWidth <= containerWidth);
      }
    };
    checkFit(); // Run initially
    window.addEventListener("resize", checkFit); // Listen for window resize

    if (service) {
      const filteredData = services.filter((item) => item._id !== service._id);
      setServicesData(filteredData);
    }
    return () => window.removeEventListener("resize", checkFit);
    
  }, [service, services , servicesData.length]);

  const handleServiceClick = (service) => {
    const encodedTitle = encodeURIComponent(service?.title?.toLowerCase().replace(/\s+/g, "-"));
    navigate(`/service-description/${encodedTitle}`, { state: { service } });
  };

  // Ensure at least 4 cards by adding placeholders
  const minCards = 0;
  const placeholdersNeeded = Math.max(0, minCards - servicesData.length);
  const placeholders = Array.from({ length: placeholdersNeeded }).map((_, index) => (
    <div key={`placeholder-${index}`} className="product-card placeholder-card">
      <div className="product-image-container">
        <div className="placeholder-image"></div>
      </div>
      <div className="product-info">
        <h3 className="placeholder-title">Coming Soon</h3>
      </div>
    </div>
  ));

  return (
<>
   
    <div className="product-slider-container">
    <h2 className="slider-title">
        Explore More <span>Services</span>
      </h2>
      <div
        className="product-slider"
        ref={sliderRef}
        style={{
          justifyContent: shouldCenter ? "center" : "flex-start",
          overflowX: shouldCenter ? "hidden" : "auto",
        }}
      >
        {servicesData.map((service) => (
          <div key={service._id} className="product-card" onClick={() => handleServiceClick(service)}>
            <div className="product-image-container">
              <img
                src={`${service.image}`}
                alt={service.title}
                className="product-image-services"
                onError={(e) => {
                  console.error(`Image failed to load: ${e.target.src}`);
                  e.target.src = "/placeholder-image.jpg";
                }}
              />
            </div>
            <div className="product-info">
              <h3 className="product-title">{service.title}</h3>
            </div>
          </div>
        ))}
        {placeholders}
      </div>
    </div>
    </>
  );
};

export default ServiceSlider;